import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessInstanceHistory } from './process-instance-history';
export { ProcessInstanceHistory };
import { processInstanceHistorySchema } from '@schemas/business-objects/process-instance-history';
import { ProcessInstanceFormGroup } from './process-instance-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class ProcessInstanceHistoryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    eventType: SchemaFormControl;
    data: SchemaFormControl;
    timestamp: SchemaFormControl;
    processInstanceId: SchemaFormControl;
    processInstance: ProcessInstanceFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ProcessInstanceHistory>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processInstanceHistorySchema, ProcessInstanceHistory, data, options);
  }

  get object(): ProcessInstanceHistory {
    return new ProcessInstanceHistory(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processInstance':
        return new ProcessInstanceFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessInstanceHistory[]> {
    return ProcessInstanceHistory.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessInstanceHistory | null> {
    return ProcessInstanceHistory.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessInstanceHistory> {
    return ProcessInstanceHistory.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessInstanceHistory>,
  ): Promise<ProcessInstanceHistory> {
    return ProcessInstanceHistory.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessInstanceHistory>,
  ): Promise<ProcessInstanceHistory> {
    return ProcessInstanceHistory.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessInstanceHistory.deleteById(id);
  }
}

export class ProcessInstanceHistoryFormArray extends PersistedFormArray {
  declare controls: ProcessInstanceHistoryFormGroup[];

  readonly entityName = 'ProcessInstanceHistory' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processInstanceHistorySchema, ProcessInstanceHistory, options);
  }

  protected override createItemGroup() {
    return new ProcessInstanceHistoryFormGroup();
  }

  get array(): ProcessInstanceHistory[] {
    return this.controls.map(
      (group: ProcessInstanceHistoryFormGroup) => group.object,
    );
  }
}

export class ProcessInstanceHistoryPersistedArray extends PersistedArray<ProcessInstanceHistory> {
  readonly entityName = 'ProcessInstanceHistory' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessInstanceHistory, options);
  }
}
